import type * as React from 'react'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import cn from 'classnames'
import styles from './SidebarItem.module.css'

interface SidebarItemProps {
  iconName: IconGlyph
  label: string
  children: React.ReactNode
}

function SidebarItemContainer({
  children,
  className,
  hideFirstBorder = true,
}: { children: React.ReactNode, className?: string, hideFirstBorder?: boolean }) {
  return (
    <dl className={cn(styles.container, hideFirstBorder && styles.hideFirstBorder, className)}>
      {children}
    </dl>
  )
}

export function SidebarItem({
  iconName,
  label,
  children,
}: SidebarItemProps) {
  return (
    <div className={styles.wrapper}>
      <dt className={styles.term}>
        <Icon glyph={iconName} size={24} className={styles.icon} aria-hidden="true" />
        <Typography className={styles.label} variant="body-s-regular-loose">
          {label}
        </Typography>
      </dt>
      <dd className={styles.content}>
        {children}
      </dd>
    </div>
  )
}

SidebarItem.Container = SidebarItemContainer
